export const COMPANY_URL = Object.freeze({
  path: '/company',
  view: {
    name: 'company.view',
    path: '/company/view',
  },
  edit: {
    name: 'company.edit',
    path: '/company/edit',
  },
  analytics: {
    name: 'company.analytics',
    path: '/company/analytics',
  },
});
